import React from "react";
import SearchableEmployeeSelect from "../../../../common/SearchableEmployeeSelect";

export default function PerCompanyConfig({
  companyUuid,
  companyName,
  companyCode,
  config,
  availableRoles,
  onChange,
  errors,
  disabled,
}) {
  const displayName = companyCode
    ? `${companyName} (${companyCode})`
    : companyName;
  const roleError = errors[`role_${companyUuid}`];

  const availableGroups = config.availableGroups || [];

  const handleGroupSelect = (index, uuid) => {
    const group = availableGroups.find((g) => g.uuid === uuid);
    if (!group) return;
    const updated = config.groups.map((g, i) =>
      i === index ? { uuid: group.uuid, name: group.name } : g
    );
    onChange("groups", updated);
  };

  const handleGroupRemove = (index) => {
    const updated = config.groups.filter((_, i) => i !== index);
    onChange("groups", updated);
  };

  const handleGroupAdd = () => {
    const usedUuids = config.groups.map((g) => g.uuid);
    const first = availableGroups.find((g) => !usedUuids.includes(g.uuid));
    if (!first) return;
    onChange("groups", [
      ...config.groups,
      { uuid: first.uuid, name: first.name },
    ]);
  };

  return (
    <div className="user-form__company-card">
      <div className="user-form__company-card-header">
        <span className="user-form__company-card-name">{displayName}</span>
        <label className="user-form__active-toggle">
          <input
            type="checkbox"
            checked={config.enabled !== false}
            onChange={(e) => onChange("enabled", e.target.checked)}
            disabled={disabled}
          />
          <span>Active</span>
        </label>
      </div>

      <div className="user-form__company-card-body">
        {/* Employee ID */}
        <div className="user-form__field">
          <SearchableEmployeeSelect
            label="Employee ID"
            value={config.employee || ""}
            onChange={(value) => onChange("employee", value)}
            placeholder="Search for employee..."
            disabled={disabled}
          />
        </div>

        {/* Role */}
        <div className="user-form__field">
          <label className="user-form__label">
            Role <span className="danger">*</span>
          </label>
          <select
            value={config.roleUuid || ""}
            onChange={(e) => onChange("roleUuid", e.target.value)}
            className={`user-form__input${roleError ? " input-error" : ""}`}
            disabled={disabled}
          >
            <option value="">Select a role</option>
            {availableRoles.map((role) => (
              <option key={role.uuid} value={role.uuid}>
                {role.name}
              </option>
            ))}
          </select>
          {roleError && <span className="user-form__error">{roleError}</span>}
        </div>

        {/* Access Groups */}
        <div className="user-form__field">
          <label className="user-form__label">Access Groups</label>
          {config.groupsLoading ? (
            <div className="user-form__groups-loading">Loading groups...</div>
          ) : availableGroups.length === 0 ? (
            <div className="user-form__groups-empty">
              No access groups configured
            </div>
          ) : (
            <>
              {config.groups.map((group, index) => {
                const otherSelectedUuids = config.groups
                  .filter((_, i) => i !== index)
                  .map((g) => g.uuid);
                const options = availableGroups.filter(
                  (ag) => !otherSelectedUuids.includes(ag.uuid)
                );
                return (
                  <div key={index} className="user-form__group-row">
                    <select
                      value={group.uuid}
                      onChange={(e) => handleGroupSelect(index, e.target.value)}
                      className="user-form__input"
                      disabled={disabled}
                    >
                      {options.map((ag) => (
                        <option key={ag.uuid} value={ag.uuid}>
                          {ag.name}
                        </option>
                      ))}
                    </select>
                    <button
                      type="button"
                      onClick={() => handleGroupRemove(index)}
                      className="user-form__group-remove"
                      disabled={disabled}
                    >
                      ×
                    </button>
                  </div>
                );
              })}
              {config.groups.length < availableGroups.length && (
                <button
                  type="button"
                  className="user-form__group-add"
                  onClick={handleGroupAdd}
                  disabled={disabled}
                >
                  + Add another access group
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
